import { useEffect } from "react";
import { useStore } from "@/store/useStore";

/**
 * Hook to manage page loading state
 * Shows global spinner when a page is loading (useful for slow internet)
 * @param {boolean} isLoading - Whether the page is currently loading
 * @param {number} delay - Delay before showing spinner (default: 300ms)
 */
export const usePageLoading = (isLoading = false, delay = 300) => {
  const { setGlobalLoading } = useStore();

  useEffect(() => {
    let timer;
    if (isLoading) {
      timer = setTimeout(() => {
        setGlobalLoading(true);
      }, delay);
    } else {
      setGlobalLoading(false);
    }

    return () => {
      clearTimeout(timer);
      setGlobalLoading(false);
    };
  }, [isLoading, delay, setGlobalLoading]);

  return null;
};

export default usePageLoading;
